export default __webpack_public_path__ + "media/9008d091085c2c76586fb3c1b50c70290d7b500939c37c32d86380821b2364d1.svg";